import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import ChipInput from 'material-ui-chip-input'
import CustomSelect from "../Select";
import {Grid, Typography} from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import {removeItemFromArray, superSplit} from "../../utils/functions";
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";
import {ThemeProvider} from "@material-ui/styles";
import Info from '@material-ui/icons/Info';
import Tooltip from "@material-ui/core/Tooltip";


const Theme = (borderRadius = '0 0 0 0') => createMuiTheme({
    overrides: {
        MuiOutlinedInput: {
            root: {
                borderRadius: borderRadius,
            },
            input: {
                padding: '10px 14px',
            }
        },
        MuiInputLabel: {
            formControl: {
                top: '-12px',
                left: '10px'
            }
        },
        MuiDialogActions: {
            root: {
                justifyContent: 'center'
            }
        },
        MuiButton: {
            root: {
                borderRadius: borderRadius,
            },
            containedPrimary: {
                color: '#fff'
            },
            contained: {
                color: '#7a865d'
            }
        }
    },
    palette: {
        primary: {
            main: '#95c61c'
        },


    },
});

class ChangePassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            oldPassword: '',
            newPassword: '',
            repeatPassword: '',
            validoldPassword: true,
            validnewPassword: true,
            validrepeatPassword: true,
        }

        this.handleClose = () => {
            this.setState({
                oldPassword: '',
                newPassword: '',
                repeatPassword: '',
                validoldPassword: true,
                validnewPassword: true,
                validrepeatPassword: true,
            })
            this.props.onClose();
        };

        this.handleSuccess = () => {

            const {oldPassword, newPassword, validoldPassword, validnewPassword, validrepeatPassword} = this.state
            if (!validoldPassword || !validnewPassword || !validrepeatPassword) return;
            this.props.onSuccess(oldPassword, newPassword);
            this.setState({
                oldPassword: '',
                newPassword: '',
                repeatPassword: ''
            })
            this.props.onClose();
        }

        this.valid = (obj) => {
            this.setState({
                ...obj,
                validoldPassword: obj.oldPassword.length > 3,
                validnewPassword: obj.newPassword.length > 3,
                validrepeatPassword: obj.repeatPassword && obj.newPassword === obj.repeatPassword,
            })
        }
    }

    render() {
        const {oldPassword, newPassword, repeatPassword, validoldPassword, validnewPassword, validrepeatPassword} = this.state;
        return (
            <div>
                <Dialog fullWidth open={this.props.open} onClose={this.handleClose} aria-labelledby="form-dialog-title"
                        style={{textAlign: "center"}}>
                    <DialogTitle id="form-dialog-title"><b>Сменить пароль</b></DialogTitle>
                    <ThemeProvider theme={Theme('34px' || '0 0 0 0')}>
                        <DialogContent style={{textAlign: "center"}}>
                            <Typography color={!validoldPassword ? 'secondary' : 'primary'}>
                                Старый пароль
                            </Typography>
                            <TextField
                                error={!validoldPassword}
                                type={'password'}
                                variant={'outlined'}
                                value={oldPassword}
                                onChange={(e) => {
                                    this.valid({...this.state, oldPassword: e.target.value});
                                }}
                                style={{marginBottom: '30px'}}
                            />
                            {!validoldPassword && <Tooltip title={'Слишком короткий пароль'}><Info color={'secondary'}
                                                                                                   style={{marginTop: '5px'}}/></Tooltip>}
                            <Typography color={!validnewPassword ? 'secondary' : 'primary'}>
                                Новый пароль
                            </Typography>
                            <TextField
                                error={!validnewPassword}
                                variant={'outlined'}
                                type={'password'}
                                value={newPassword}
                                onChange={(e) => {

                                    this.valid({...this.state, newPassword: e.target.value});
                                }}
                                style={{marginBottom: '30px'}}
                            />
                            {!validnewPassword && <Tooltip title={'Слишком короткий пароль'}><Info color={'secondary'}
                                                                                                   style={{marginTop: '5px'}}/></Tooltip>}
                            <Typography color={!validrepeatPassword ? 'secondary' : 'primary'}>
                                Новый пароль еще раз
                            </Typography>
                            <TextField
                                variant={'outlined'}
                                error={!validrepeatPassword}
                                value={repeatPassword}
                                type={'password'}
                                style={{marginBottom: '30px'}}
                                onChange={(e) => {
                                    this.valid({...this.state, repeatPassword: e.target.value});
                                }}
                            />
                            {!validrepeatPassword && <Tooltip title={'Пароли не совпадают'}><Info color={'secondary'}
                                                                                                  style={{marginTop: '5px'}}/></Tooltip>}
                        </DialogContent>
                        <DialogActions>
                            <Button variant={'contained'} onClick={this.handleClose} color="default">
                                Отмена
                            </Button>
                            <Button variant={'contained'} onClick={() => {
                                this.valid(this.state);
                                this.handleSuccess();
                            }} color="primary">
                                Готово
                            </Button>
                        </DialogActions>
                    </ThemeProvider>
                </Dialog>
            </div>
        );
    }
}

export default ChangePassword